import React from 'react';

import {
  Briefcase,
  Flux,
  License,
  RandstadCircle,
  Refresh,
} from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import { Chrono } from '@randstad-lean-mobile-factory/react-assets/dist/icons';

import { MenuSection } from 'src/Components/MenuSection/MenuSection.types';

export enum ADMIN_FIRST_SECTION {
  business = 'business',
  apps = 'apps',
  mbapi = 'mbapi',
  parameters = 'parameters',
}

export enum ADMIN_SECOND_SECTION {
  // business
  cgc = 'cgc',
  qualifications = 'qualifications',
  routing = 'routing',
  onCallCenters = 'onCallCenters',
  // apps
  home = 'home',
  // mbapi
  routes = 'routes',
  // parameters
  rights = 'rights',
  cronJobs = 'cronJobs',
}

export const menuItems: MenuSection<[ADMIN_FIRST_SECTION, ADMIN_SECOND_SECTION]>[] = [
  {
    title: 'référentiel métier',
    item: ADMIN_FIRST_SECTION.business,
    items: [
      {
        title: 'unité & CGC',
        item: ADMIN_SECOND_SECTION.cgc,
        iconSelected: <RandstadCircle variant="fill" color="white" />,
        iconNotSelected: <RandstadCircle variant="fill" />,
      },
      {
        title: 'qualifications',
        item: ADMIN_SECOND_SECTION.qualifications,
        iconSelected: <Briefcase variant="fill" color="white" />,
        iconNotSelected: <Briefcase variant="fill" />,
      },
      {
        title: 'routage',
        item: ADMIN_SECOND_SECTION.routing,
        iconSelected: <Flux variant="fill" color="white" />,
        iconNotSelected: <Flux variant="fill" />,
      },
      {
        title: 'perm & unité',
        item: ADMIN_SECOND_SECTION.onCallCenters,
        iconSelected: <RandstadCircle variant="fill" color="white" />,
        iconNotSelected: <RandstadCircle variant="fill" />,
      },
    ],
  },
  {
    title: 'portail mobilité',
    item: ADMIN_FIRST_SECTION.apps,
    items: [
      {
        title: 'infos apps',
        item: ADMIN_SECOND_SECTION.home,
        iconSelected: <Refresh variant="fill" color="white" />,
        iconNotSelected: <Refresh variant="fill" />,
      },
    ],
  },
  {
    title: 'mbapi',
    item: ADMIN_FIRST_SECTION.mbapi,
    items: [
      {
        title: 'administration',
        item: ADMIN_SECOND_SECTION.routes,
        iconSelected: <Flux variant="fill" color="white" />,
        iconNotSelected: <Flux variant="fill" />,
      },
    ],
  },
  {
    title: 'paramètres',
    item: ADMIN_FIRST_SECTION.parameters,
    items: [
      {
        title: 'gestion droits',
        item: ADMIN_SECOND_SECTION.rights,
        iconSelected: <License variant="fill" color="white" />,
        iconNotSelected: <License variant="fill" />,
      },
      {
        title: 'tâches programmées',
        item: ADMIN_SECOND_SECTION.cronJobs,
        iconSelected: <Chrono variant="fill" color="white" />,
        iconNotSelected: <Chrono variant="fill" />,
      },
    ],
  },
];
